import { Box, Divider, Stack, Typography, useTheme } from "@mui/material";
import merge from "lodash/merge";

import { FAQAccordion, originalSkin } from "../../../../Components/FAQ/FAQAccordion";
import { fsk8sFaqs } from "./content";

const Faq = () => {
  const theme = useTheme();

  const faqAccordionProps = merge(originalSkin(theme), {
    AccordionProps: {
      sx: {
        backgroundColor: "transparent",
      },
    },
    QuestionTypographyProps: {
      sx: {
        fontWeight: 400,
      },
    },
  });

  return (
    <Box>
      <Stack spacing={2}>
        <Typography variant="h3">Frequently asked questions</Typography>
        <Box>
          <Divider />
          <FAQAccordion faqs={fsk8sFaqs} props={faqAccordionProps} />
        </Box>
      </Stack>
    </Box>
  );
};

export default Faq;
